<template>
  <div v-if="show">
    <v-row class="mb-2 align-center staggered-row">
      <v-col cols="5" sm="6">
        <span class="text-subtitle-1 font-weight-medium">출소일</span>
      </v-col>
      <v-col cols="7" sm="6" class="text-right">
        <span class="fluid-date font-weight-bold text-primary">{{ formattedDDayDate }}</span>
      </v-col>
    </v-row>

    <v-row class="mb-2 align-center staggered-row">
      <v-col cols="5" sm="6">
        <span class="text-subtitle-1 font-weight-medium">전체 형기 1/3</span>
        <div class="text-caption text-grey">가석방 심사 대상 가능일</div>
      </v-col>
      <v-col cols="7" sm="6" class="text-right">
        <span class="fluid-date font-weight-bold">{{ formattedOneThirdDate }}</span>
      </v-col>
    </v-row>

    <v-row class="mb-4 align-center staggered-row">
      <v-col cols="5" sm="6">
        <span class="text-subtitle-1 font-weight-medium">전체 형기 2/3</span>
      </v-col>
      <v-col cols="7" sm="6" class="text-right">
        <span class="fluid-date font-weight-bold">{{ formattedTwoThirdsDate }}</span>
      </v-col>
    </v-row>

    <v-divider class="my-4"></v-divider>

    <v-row class="align-center staggered-row">
      <v-col cols="12" sm="6">
        <v-text-field
          :model-value="paroleDate"
          @update:model-value="$emit('update:paroleDate', $event)"
          label="가장 빠른 예상 가석방일"
          type="date"
          required
          @change="$emit('calculateRate')"
          variant="outlined"
          color="primary"
          persistent-hint
          :hint="paroleDateSuffix"
          prepend-inner-icon="mdi-calendar"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" class="d-flex align-center justify-center justify-sm-end">
        <div v-if="paroleRate !== null" class="text-right">
          <h3 class="text-h6 font-weight-bold text-center text-sm-right">
            <v-menu location="bottom end">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" color="primary" class="mr-1" style="vertical-align: super; font-size: 1.2rem; cursor: pointer;" @click="Track_help">
                  mdi-help-circle
                </v-icon>
              </template>
              <v-card max-width="300" class="pa-3" style="border-radius: 12px;">
                <div class="text-body-2" style="line-height: 1.6; word-break: keep-all; text-align: left;">
                  가석방 출소는 매월 말일 기준입니다. 말일이 공휴일이라면, 그 직전 평일에 출소합니다.<br>
                  "<b>가장 빠른 예상 가석방일</b>"에 원하는 날짜를 입력해보세요. 그 날이 전체 형기의 몇 퍼센트인지 계산됩니다.
                </div>
              </v-card>
            </v-menu>
            가석방 <span class="text-primary">{{ paroleRate }}%</span> 받음 <br>
            <span style="font-size: 60%; color:#AAAAAA;" >전체 형기 중 가석방의 비율입니다.</span>
          </h3>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { analytics } from '../firebase';
import { logEvent } from "firebase/analytics";

export default {
  name: 'ParoleResults',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formattedDDayDate: {
      type: String,
      default: ''
    },
    formattedOneThirdDate: {
      type: String,
      default: ''
    },
    formattedTwoThirdsDate: {
      type: String,
      default: ''
    },
    paroleDate: {
      type: String,
      default: ''
    },
    paroleRate: {
      type: [Number, String],
      default: null
    },
    paroleDateSuffix: {
      type: String,
      default: ''
    }
  },
  emits: ['update:paroleDate', 'calculateRate'],
  methods: {
    /**
     * 도움말 아이콘 클릭 시 GA 이벤트를 기록합니다.
     */
    Track_help() {
      logEvent(analytics, 'click_help_circle');
    }
  }
}
</script>

<style scoped>
.fluid-date {
  font-size: clamp(0.9rem, 4vw, 1.25rem);
  white-space: nowrap;
}

.staggered-row {
  opacity: 0;
  transform: translateY(10px);
  animation: fadeIn 0.5s ease forwards;
}

.staggered-row:nth-child(1) { animation-delay: 0.1s; }
.staggered-row:nth-child(2) { animation-delay: 0.2s; }
.staggered-row:nth-child(3) { animation-delay: 0.3s; }
.staggered-row:nth-child(5) { animation-delay: 0.4s; } /* Divider is 4th child */

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
